import React, { useState } from 'react';
import { APIRequestSort } from 'global';
import { useQuery } from '@apollo/client';
import { FormInput } from 'components/form';
import { Button, Stack } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { MUITablePagination } from 'components/shared/MUITable';

import { DealSheetRulesTable } from './table';
import { DealSheetRulesFilterType } from './types';
import { DealSheetRulesTableFilter } from './filters';
import { dealSheetConfigurationApi } from '../../api';
import { initialDealSheetRulesFiltersValue } from './constants';

export const RulesTableContainer = ({ onCreateRule }: { onCreateRule: VoidFunction }) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState<boolean>(false);

  const [search, setSearch] = useState<string>('');
  const [filters, setFilters] = useState(initialDealSheetRulesFiltersValue);
  const [sorting, setSorting] = useState<APIRequestSort>({ key: 'created_date_time', value: 'desc' });
  const [pagination, setPagination] = useState<Omit<MUITablePagination, 'onChange' | 'total'>>({
    page: 1,
    perPage: 15,
  });

  const { data, loading } = useQuery(dealSheetConfigurationApi.getTableConfigs, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        filters: {
          ...filters,
          [DealSheetRulesFilterType.CUSTOMER_TYPE]: filters[DealSheetRulesFilterType.CUSTOMER_TYPE].map(
            ({ value }) => value
          ),
          [DealSheetRulesFilterType.PAYMENT_TYPE]: filters[DealSheetRulesFilterType.PAYMENT_TYPE].map(
            ({ value }) => value
          ),
          [DealSheetRulesFilterType.EQUIPMENT_TYPE]: filters[DealSheetRulesFilterType.EQUIPMENT_TYPE].map(
            ({ value }) => value
          ),
        },
        search,
        sorting,
        pagination,
        ...(search ? { search } : {}),
      },
    },
  });

  const tableData = data?.dealSheets?.result?.items ?? [];

  return (
    <Stack gap="0.5rem">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" gap="0.5rem" minWidth="50%">
          <FormInput
            value={search}
            variant="outlined"
            label="Search by name or description"
            onChange={value => setSearch(value)}
          />

          <Button
            variant="outlined"
            startIcon={<FilterList />}
            onClick={() => setIsFiltersOpen(prevState => !prevState)}
          >
            Filters
          </Button>
        </Stack>

        <Stack direction="row" gap="0.5rem">
          <Button variant="contained" onClick={onCreateRule}>
            Create New Rule
          </Button>
        </Stack>
      </Stack>

      <DealSheetRulesTable
        isLoading={loading}
        tableData={tableData}
        sorting={{ ...sorting, onChange: setSorting }}
        pagination={{
          ...pagination,
          total: data?.dealSheets?.result?.pagination?.total ?? 0,
          onChange: nextValue => setPagination(prev => ({ ...prev, ...nextValue })),
        }}
      />

      <DealSheetRulesTableFilter open={isFiltersOpen} onClose={() => setIsFiltersOpen(false)} onChanged={setFilters} />
    </Stack>
  );
};
